export const SOURCE_TYPES = ['qr_code', 'nfc_tap', 'manual'];
export const DEFAULT_SOURCE_TYPE = 'nfc_tap';

export function resolveSourceType(value) {
  if (value === 'qr_code' || value === 'manual' || value === 'nfc_tap') {
    return value;
  }
  return DEFAULT_SOURCE_TYPE;
}

export function resolveScanSourceType(searchParams) {
  const fromQuery = searchParams?.get?.('source_type');
  if (fromQuery) {
    return resolveSourceType(fromQuery);
  }
  return DEFAULT_SOURCE_TYPE;
}
